import { COLORS } from '../../../constants';

const MuiTableCell = {
    root: {
        fontSize: '16px',
        color: COLORS.SECONDARY,
        border: 'none',
    },
    head: {
        fontWeight: 'bold',
    },
};

export default MuiTableCell;
